import SCInput from "@/components/sc-controls/form-controls/sc-input";
import { useState } from "react";
import {Button, Flex} from "@mantine/core";
import {Title} from "@mantine/core";
import SCModal from "@/PageComponents/Modal/SCModal";

export default function ManageTableHeading({ definition, setDefinition, onDismiss }: any) {

    const [def, setDef] = useState(definition);

    const updateDef = ({ name, value }: any) => {
        setDef({
            ...def,
            [name]: value
        });
    };

    const onUpdate = () => {
        setDefinition && setDefinition(def);
        onDismiss && onDismiss();
    };

    return (<>

        {/*<SCModal title="Edit Heading" onDismiss={onDismiss}>*/}

        <SCModal
            open={true}
            onClose={onDismiss}
            withCloseButton
            size={550}
        >

            <Title
                c={'scBlue'}
                order={4}
            >
                {def.label ? 'Create Heading' : 'Edit Heading'}
            </Title>


            <SCInput
                name={"Label"}
                value={def.Label}
                onChange={updateDef}
                autoFocus={true}
            />

            <Flex justify={'end'} gap={5} mt={'xl'}>
                <Button variant="outline" onClick={onDismiss} >Cancel</Button>
                <Button onClick={onUpdate} >Update</Button>
            </Flex>
        </SCModal>

        <style jsx>{`
        
        .row {
            display: flex;
        }

        .row.align-right {
            justify-content: flex-end;
        }

        `}</style>
    </>);
}